import React from "react";

export default function Footer() {
  return (
    <footer
      className="flex justify-content-center align-items-center p-3 mt-auto"
      style={{
        // backgroundColor: "#ffffff",
        color: "#FC5F1CFF",
        fontWeight: "bold",
        borderTop: "1px solid #eee",
      }}
    >
      Copyright © {new Date().getFullYear()} Auxfin. All Rights Reserved.
    </footer>
  );
}
